export default {
  async fetchBusinessVariables({ commit }) {
    try {
      const data = await this.$axios.$get(`${this.$config.baseOfixApi}/e-commerce/v1/settings`);
      commit('setBusinessVariables', { data });
    } catch (e) {}
  },

  resetState({ dispatch }) {
    dispatch('fetchBusinessVariables');
  },
};
